import { isArray } from 'lodash-es'
import { List, Map } from 'immutable'

export const defaultListMerger = (objValue, srcValue) => {
  if (!objValue.mergeWith) {
    return srcValue
  }
  return objValue.mergeWith(deepMerger, srcValue)
}

export const reverseListMerger = (objValue, srcValue) => {
  if (!objValue.mergeWith) {
    return srcValue
  }
  return objValue.mergeWith(reverseDeepMerger, srcValue)
}

export const listReplacer = (objValue, srcValue) => {
  if (!objValue.mergeWith) {
    return srcValue
  }
  return objValue.mergeWith(deepReplacer, srcValue)
}

const deepMerger = (objValue, srcValue) => {
  if (List.isList(objValue) && List.isList(srcValue)) {
    return objValue
      .concat(srcValue)
      .toOrderedSet()
      .toList()
  } else if (Map.isMap(objValue) && Map.isMap(srcValue)) {
    return objValue.mergeWith(deepMerger, srcValue)
  }
  return srcValue !== undefined ? srcValue : objValue
}

const reverseDeepMerger = (objValue, srcValue) => {
  if (List.isList(objValue) && List.isList(srcValue)) {
    return srcValue
      .concat(objValue)
      .toOrderedSet()
      .toList()
  } else if (Map.isMap(objValue) && Map.isMap(srcValue)) {
    return objValue.mergeWith(reverseDeepMerger, srcValue)
  }
  return srcValue !== undefined ? srcValue : objValue
}

const deepReplacer = (objValue, srcValue) => {
  return srcValue
}

export const defaultMergeWithCustomizer = (objValue, srcValue) => {
  if (isArray(objValue)) {
    return [...new Set([...objValue, ...srcValue])]
  }
}

export const concatArraysMergeWithCustomizer = (objValue, srcValue) => {
  if (isArray(objValue)) {
    return [...objValue, ...srcValue]
  }
}

export const arraySubstituter = (objValue, srcValue) => {
  if (isArray(objValue)) {
    return [...new Set([...srcValue])]
  }
}
